/**
 * gem-stone-swap.js  v7.2
 *
 * v7.1からの変更点:
 *   - bindStoneSwatchEvents() のバインド対象を「お石オプション配下のスウォッチ」に限定。
 *     従来は .mw-option__value[data-value-id] を全件対象にしていたため、
 *     地金カラー等の他オプションのスウォッチも誤ってバインド候補になっていた。
 *     getStoneOptionSelector() でお石オプションIDを特定し、その配下のみを対象にする。
 *   - bound Set のチェックロジックは維持しつつ、APOの再描画後に
 *     新しいvalue-idが生成された場合も確実にバインドできるよう改善。
 *   - MutationObserverのタイマーを300ms→500msに延長し、
 *     APO描画完了をより確実に待つようにした。
 */

(function () {
  'use strict';

  // ページロード時に product-media → ファイル名 のマップを先に構築する
  var mediaMap = {}; // { mediaId: filename }

  function buildMediaMap() {
    document.querySelectorAll('.product-media').forEach(function (media) {
      var mediaId = media.getAttribute('data-media-id');
      if (!mediaId) return;

      var img = media.querySelector('img');
      if (!img) return;

      // srcset → src → data-lazy-src → data-src の順で取得
      var src = '';
      var srcset = img.getAttribute('srcset') || img.getAttribute('data-srcset') || '';
      if (srcset) {
        src = srcset.split(',')[0].trim().split(' ')[0];
      }
      if (!src) src = img.src || '';
      if (!src) src = img.getAttribute('data-lazy-src') || '';
      if (!src) src = img.getAttribute('data-src') || '';

      if (!src) return;

      var filename = src.split('?')[0].split('/').pop().toLowerCase();
      if (filename) {
        mediaMap[mediaId] = filename;
      }
    });
    console.log('[gem-stone-swap] mediaMap構築:', Object.keys(mediaMap).length + '件');
  }

  function getMediaId(stoneNum) {
    var key = '-' + stoneNum.toLowerCase() + '-';
    var stoneResult = null;
    var colorResult = null;

    Object.keys(mediaMap).forEach(function (mediaId) {
      var filename = mediaMap[mediaId];
      if (filename.indexOf(key) === -1) return;

      if (!stoneResult && filename.indexOf('-stone') !== -1) {
        stoneResult = mediaId;
      }
      if (!colorResult) {
        colorResult = mediaId;
      }
    });

    var result = stoneResult || colorResult;
    if (!result) {
      // mediaMapが古い可能性があるので再構築して再試行
      buildMediaMap();
      Object.keys(mediaMap).forEach(function (mediaId) {
        var filename = mediaMap[mediaId];
        if (filename.indexOf(key) === -1) return;
        if (!result && filename.indexOf('-stone') !== -1) result = mediaId;
        if (!result) result = mediaId;
      });
    }

    if (!result) {
      console.warn('[gem-stone-swap] 石' + stoneNum + ' のmedia-idが見つかりません');
    }
    return result;
  }

  function showStoneMedia(stoneNum) {
    var mediaId = getMediaId(stoneNum);
    if (!mediaId) return;

    var thumb = document.querySelector('a.thumbnail[data-media-id="' + mediaId + '"]');
    if (!thumb) {
      console.warn('[gem-stone-swap] サムネイルが見つかりません media-id:' + mediaId);
      return;
    }

    console.log('[gem-stone-swap] サムネイルクリック: 石' + stoneNum + ' media-id:' + mediaId);

    var href = thumb.getAttribute('href');
    if (href) {
      var image = new Image();
      image.onload = function () { thumb.click(); };
      image.onerror = function () { thumb.click(); };
      image.src = href;
    } else {
      thumb.click();
    }
  }

  function getStoneNumFromContainer(container) {
    var labelEl = container.querySelector('[data-original-text]');
    if (labelEl) {
      var orig = labelEl.getAttribute('data-original-text') || '';
      var stockMatch = orig.match(/\[stock(\w+)\]/i);
      if (stockMatch) return 'stock' + stockMatch[1];
      var numMatch = orig.match(/#(\d{3})/);
      if (numMatch) return numMatch[1];
    }
    var img = container.querySelector('img');
    if (img) {
      var src = img.src || img.getAttribute('data-lazy-src') || '';
      var filename = src.split('?')[0].split('/').pop();
      var stockFile = filename.match(/-(stock\w+)[-_]/i);
      if (stockFile) return stockFile[1];
      var numFile = filename.match(/-(\d{3})-/);
      if (numFile) return numFile[1];
    }
    return null;
  }

  /* -------------------------------------------------------
     お石オプションのCSSセレクタを取得
     「お石」を含むオプションのIDを探し、その配下のスウォッチに限定する。
     これにより地金カラー等の他オプションを誤ってバインドしない。
  ------------------------------------------------------- */
  function getStoneOptionSelector() {
    var selectors = [];
    document.querySelectorAll('.mw-option[data-option-id]').forEach(function (option) {
      var title = option.querySelector('.mw-option__title, .mw-label, [class*="title"]');
      if (title && title.textContent.indexOf('お石') !== -1) {
        var optionId = option.getAttribute('data-option-id');
        selectors.push('.mw-option[data-option-id="' + optionId + '"] .mw-option__value[data-value-id]');
      }
    });
    return selectors.join(', ');
  }

  var bound = new Set();

  function bindStoneSwatchEvents() {
    // お石オプション配下のスウォッチのみを対象にする
    var selector = getStoneOptionSelector();
    if (!selector) {
      console.warn('[gem-stone-swap] お石オプションが見つかりません');
      return;
    }

    var containers = document.querySelectorAll(selector);
    console.log('[gem-stone-swap] バインド対象:', containers.length + '件');

    containers.forEach(function (container) {
      var valueId = container.getAttribute('data-value-id');
      if (!valueId || bound.has(valueId)) return;

      var stoneNum = getStoneNumFromContainer(container);
      if (!stoneNum) return;

      bound.add(valueId);

      function onStoneClick() {
        var num = getStoneNumFromContainer(container) || stoneNum;
        console.log('[gem-stone-swap] クリック: 石' + num);
        showStoneMedia(num);
      }
      container.addEventListener('click', onStoneClick);
      var labelEl = container.querySelector('label');
      if (labelEl) labelEl.addEventListener('click', onStoneClick);

      console.log('[gem-stone-swap] バインド: ' + valueId + ' → 石' + stoneNum);
    });
  }

  function observeApo() {
    var target = document.querySelector('.mw-apo-container') || document.body;
    var timer = null;
    new MutationObserver(function () {
      clearTimeout(timer);
      // v7.2: 300ms → 500ms に延長してAPO描画完了をより確実に待つ
      timer = setTimeout(bindStoneSwatchEvents, 500);
    }).observe(target, { childList: true, subtree: true });
  }

  function showInitialStone() {
    var selector = getStoneOptionSelector();
    if (!selector) return;
    var checked = document.querySelector(selector.split(',').map(function(s) {
      return s.trim() + ' input.mw-option__control:checked';
    }).join(', '));
    if (!checked) return;
    var valueEl = checked.closest('.mw-option__value');
    if (!valueEl) return;
    var stoneNum = getStoneNumFromContainer(valueEl);
    if (!stoneNum) return;
    console.log('[gem-stone-swap] 初期石:', stoneNum);
    showStoneMedia(stoneNum);
  }

  function init() {
    buildMediaMap();

    bindStoneSwatchEvents();
    observeApo();
    setTimeout(bindStoneSwatchEvents, 800);
    setTimeout(bindStoneSwatchEvents, 1500);
    setTimeout(showInitialStone, 600);
    setTimeout(showInitialStone, 1800);

    // 画像のロード完了後にmediaMapを再構築（Safari対策）
    window.addEventListener('load', function () {
      buildMediaMap();
      bindStoneSwatchEvents();
      console.log('[gem-stone-swap] load後にmediaMap再構築・バインド完了');
    });

    console.log('[gem-stone-swap] 初期化完了 (v7.2)');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();